import { Component, OnInit } from '@angular/core';
import { DepartmentBase } from '../department.base';

@Component({
  selector: 'dpto-88',
  templateUrl: './dpto88.component.html',
  styleUrls: ['../department/department.component.css']
})
export class Dpto88Component extends DepartmentBase {
  municipalities=[{"id":1087,"code":"88001","name":"San Andr\u00e9s","state":"1","department_code":"88"},{"id":1088,"code":"88564","name":"Providencia","state":"1","department_code":"88"}]
}
